"use client";

import React from "react";
import { HeartHandshake, ShieldCheck, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Tissue Preservation",
  description: "Our 'Patient as Family' philosophy drives us to use techniques that spare healthy muscle and nerves, ensuring the most gentle surgical experience possible.",
  icon: HeartHandshake
}, {
  title: "Precision Microsurgery",
  description: "We utilize state-of-the-art neuro-navigation and high-definition visualization to perform intricate procedures with sub-millimeter accuracy and safety.",
  icon: ShieldCheck
}, {
  title: "Rapid Recovery",
  description: "By utilizing advanced minimally invasive technology, we achieve effective results with smaller incisions, significantly less pain, and faster returns to daily life.",
  icon: Sparkles
}];
function FeatureItem({
  feature,
  index
}: {
  feature: typeof features[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="75647" ref={ref} data-index={index} className={`flex flex-col items-start transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="mb-8 flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-secondary shadow-lg shadow-secondary/10 border border-secondary/30 backdrop-blur-sm">
        <feature.icon className="h-10 w-10 stroke-[1.25]" />
      </div>
      <h3 className="mb-4 font-sans font-bold text-[20px] leading-tight text-primary-foreground tracking-tight">
        {feature.title}
      </h3>
      <p className="font-sans font-normal leading-relaxed text-primary-foreground/70">
        {feature.description}
      </p>
    </div>;
}
export default function WhyChooseSmileCraft() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="the-minimally-invasive-difference" className="relative overflow-hidden bg-primary py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] h-[70%] w-[50%] rounded-full bg-secondary/10 blur-[120px]" />
        <div className="absolute top-[40%] -right-[10%] h-[60%] w-[40%] rounded-full bg-accent/5 blur-[100px]" />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-1000 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-sans font-bold text-3xl tracking-tight text-primary-foreground sm:text-4xl md:text-5xl">
            The Minimally Invasive Difference
          </h2>
        </div>
        
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-16 gap-y-16 sm:mt-24 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {features.map((feature, i) => <FeatureItem key={i} feature={feature} index={i} />)}
        </div>
      </div>
    </section>;
}